import request from '@/utils/request'
//获取轮播图list
export function getBaList(data) {
  return request({
    url: '/index/index/brand',
    method: 'post',
    data: data,
  })
}
